module.exports = __webpack_public_path__ + "img/深圳国际交流中心.b793e339.png";